/**
 * @file: SupportPage.js
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Link, useNavigate } from 'react-router-dom'
import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import withAppStore from '../../util/withAppStore'

import AppDispatcher from '../../dispatchers/AppDispatcher'
import AppStore from '../../stores/AppStore'

import styles from '../../../css/devicePage.module.css'
import docStyles from '../../../css/doc.module.css'

function SupportPage (props) {
  const navigate = useNavigate()

  const [state, setState] = React.useState({
    hasManuals: false,
    hasStationStups: false,
  })

  const getDocs = React.useCallback(() => {
    const {
      locale: {
        language,
      },
    } = AppStore.getUser()

    AppDispatcher.dispatch({
      action: 'get-docs',
      params: { language },
      callback: () => {
        const {
          data: {
            docs: {
              docs,
            } = {},
          },
        } = AppStore

        if (Array.isArray(docs)) {
          const hasManuals = docs.some((doc) => doc.category === 'manuals')
          const hasStationSetups = docs.some((doc) => doc.category === 'stationSetup')

          if (hasManuals || hasStationSetups) {
            const newState = {
              hasManuals,
              hasStationSetups,
            }

            setState(newState)
          }
        }
      },
    })
  }, [])

  const goBack = React.useCallback(() => {
    navigate('/')
  }, [navigate])

  React.useEffect(() => {
    window.scrollTo(0, 0) // start at top
    getDocs()
  }, [getDocs])

  const {
    auth: { logout: logoutFn },
    intl: { formatMessage },
    route: { path: page },
    data: {
      customer: {
        data: {
          id: customerID,
        },
      },
    },
    pages,
  } = props

  const {
    data: {
      docs: {
        docs,
      } = {},
      user: {
        locale = 'en',
        permissions: {
          level,
        },
      },
    },
  } = AppStore

  let hasManuals
  let hasStationSetups

  if (Array.isArray(docs)) {
    hasManuals = docs.some((doc) => doc.category === 'manuals')
    hasStationSetups = docs.some((doc) => doc.category === 'stationSetup')
  }

  const logout = () => logoutFn(navigate)

  const SUPPORT = formatMessage({
    id: 'support.page.title',
    defaultMessage: 'Support',
  })

  return (
    <div>
      <Helmet><title>{SUPPORT || pages.SupportPage}</title></Helmet>
      <NavigationBar
        backFunc={goBack}
        name={SUPPORT}
        page={page}
        logOut={logout}
      />
      <div className={styles.pageWidth}>
        <section className={docStyles.doc}>
          <ul>
            {hasManuals && (
              <FormattedMessage
                id='support.manuals'
                defaultMessage='Manuals'
              >
                {(txt) => <Link to={`/docs?category=manuals&locale=${locale}`}>{txt}</Link>}
              </FormattedMessage>
            )}
            {hasStationSetups && (
              <FormattedMessage
                id='support.station.setup'
                defaultMessage='Station Setup'
              >
                {(txt) => <Link to={`/docs?category=stationSetup&locale=${locale}`}>{txt}</Link>}
              </FormattedMessage>
            )}
            <FormattedMessage
              id='support.contact'
              defaultMessage='Contact Support'
            >
              {(txt) => (
                <a
                  href='https://altrac.zendesk.com/hc/en-us/requests/new'
                  target='_blank' rel='noreferrer'
                >
                  {txt}
                </a>
              )}
            </FormattedMessage>
            {level >= 20
              ? (
                <FormattedMessage
                  id='support.api.keys'
                  defaultMessage='Altrac API Keys'
                >
                  {(txt) => <Link to={`/support/${customerID}/apiKeys`}>{txt}</Link>}
                </FormattedMessage>
                )
              : ''}
          </ul>
        </section>
        <div className={styles.endSpace} />
      </div>
      <Footer />
    </div>
  )
}

SupportPage.propTypes = {
  auth: PropTypes.object,
  intl: PropTypes.object,
  route: PropTypes.object,
  data: PropTypes.object,
  pages: PropTypes.object,
}

export default withAppStore(injectIntl(SupportPage))
